<template>
  <section class="winners-2021-section">
    <div class="container">
      <div class="grid-box">
        <Winners2021Winner />
        <ul class="winners-2021-section__list row">
          <li class="col-12 col-lg-6">
            <Winners2021PlaceWinnersCard :prizes="winner2nd.prizes" grow-prizes>
              <template #title>2 место</template>
              <template #winners>
                <Winners2021PlaceWinnersCardWinnerStand
                  :user="winner2nd.user"
                />
              </template>
            </Winners2021PlaceWinnersCard>
          </li>
          <li class="col-12 col-lg-6">
            <Winners2021PlaceWinnersCard :prizes="winner3rd.prizes" grow-prizes>
              <template #title>3 место</template>
              <template #winners>
                <Winners2021PlaceWinnersCardWinnerStand
                  :user="winner3rd.user"
                />
              </template>
            </Winners2021PlaceWinnersCard>
          </li>
          <li
            v-for="(info, index) in winners"
            :key="index"
            class="col-12 col-lg-6"
          >
            <Winners2021PlaceWinnersCard :prizes="info.prizes" grow-winners>
              <template #title>{{ info.title }}</template>
              <template #winners>
                <Winners2021PlaceWinnersCardWinnersList
                  :winners="info.winners"
                />
              </template>
            </Winners2021PlaceWinnersCard>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Winners2021Winner from "./Winners2021Winner";
import Winners2021PlaceWinnersCard from "./Winners2021PlaceWinnersCard";
import Winners2021PlaceWinnersCardWinnersList from "./Winners2021PlaceWinnersCardWinnersList";
import Winners2021PlaceWinnersCardWinnerStand from "./Winners2021PlaceWinnersCardWinnerStand";
import { prizesDict } from "./data";

export default {
  name: "Winners2021Section",
  components: {
    Winners2021Winner,
    Winners2021PlaceWinnersCardWinnersList,
    Winners2021PlaceWinnersCardWinnerStand,
    Winners2021PlaceWinnersCard
  },
  data: () => ({
    winner: {
      id: 3793,
      nickname: "Константин?нет Вячеслав",
      steam_id64: "76561198842527594",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/2b/2be6d1dfe1534383e3a5fea9aebbf866de86bdaa_full.jpg"
    },
    winner2nd: {
      prizes: [
        prizesDict["aoc-c27g2u"],
        prizesDict["cooler-master-caliber-r1"],
        prizesDict["hyperx-quadcast"],
        prizesDict["hyperx-alloy-origins"],
        prizesDict["hyperx-pulsefire-surge"],
        prizesDict["hyperx-fury-ultra"],
        prizesDict["cooler-master-jacket"]
      ],
      user: {
        id: 5136,
        nickname: "2 years & 8 months",
        steam_id64: "76561198239825010",
        avatar:
          "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/50/50a82cfdb7b1c8ba01c962e31f0fa193f1632c23_full.jpg"
      }
    },
    winner3rd: {
      prizes: [
        prizesDict["cooler-master-caliber-r1"],
        prizesDict["hyperx-alloy-origins"],
        prizesDict["hyperx-pulsefire-surge"],
        prizesDict["cooler-master-jacket"]
      ],
      user: {
        id: 5239,
        nickname: "chistor_",
        steam_id64: "76561198122105623",
        country: null,
        avatar:
          "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/d9/d9e5a5dd7b49b2b55c85f61445dbf8809f21122e_full.jpg"
      }
    },
    winners: [
      {
        title: "4-8 место",
        prizes: [
          prizesDict["cooler-master-mb511-argb"],
          prizesDict["hyperx-alloy-origins"],
          prizesDict["hyperx-pulsefire-surge"],
          prizesDict["cooler-master-tshirt"]
        ],
        winners: [
          {
            id: 3364,
            nickname: "VENOM",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/40/409a3497305de2ef524d1d70daad4eb5cc207cdb_full.jpg",
            country: null,
            steam_id64: "76561198846921001"
          },
          {
            id: 4433,
            nickname: "ruby leveled up",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/09/095aee112b0b420334e9d89aa103b2563679e6b0_full.jpg",
            country: null,
            steam_id64: "76561199040460573"
          },
          {
            id: 3949,
            nickname: "No Longer Human",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/1e/1efb5ecd1aabe4d69e281208601497b403d4f783_full.jpg",
            country: null,
            steam_id64: "76561198873778858"
          },
          {
            id: 283,
            nickname: "imaten",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/9a/9a06de5fdf0a26ee58753548b00e0b9a16742afc_full.jpg",
            country: null,
            steam_id64: "76561198325777920"
          },
          {
            id: 251,
            nickname: "KAtala",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/f8/f8f46b29fa8993e68b782565989b93c6fedfc763_full.jpg",
            country: null,
            steam_id64: "76561198161942510"
          }
        ]
      },
      {
        title: "9-16 место",
        prizes: [
          prizesDict["cooler-master-mb511-argb"],
          prizesDict["hyperx-fury-ultra"],
          prizesDict["cooler-master-tshirt"]
        ],
        winners: [
          {
            id: 2757,
            nickname: "Wotto",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/ef/efa9f532d5379d210eaa69fe065b8cdf8c0bb773_full.jpg",
            country: "RU",
            steam_id64: "76561198023010892"
          },
          {
            id: 3964,
            nickname: "Нищий",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/eb/ebd0344ff7008d8a9efc873585077ea0b937a299_full.jpg",
            country: null,
            steam_id64: "76561198835005076"
          },
          {
            id: 5087,
            nickname: "2",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/c5/c555920a0cafc0c52d741ae09ff01d3a24857ee2_full.jpg",
            country: null,
            steam_id64: "76561198051726571"
          },
          {
            id: 3754,
            nickname: "Faust",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/52/52b04fa8fa2616b311a5b26dfc4fa92cb29c1886_full.jpg",
            country: null,
            steam_id64: "76561198160088515"
          },
          {
            id: 3771,
            nickname: "Shergarat (Vladimir) DEMENTED",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/6c/6c66b412ed8cc03de80a5ff2b1d33acab6db730b_full.jpg",
            country: "RU",
            steam_id64: "76561198333067115"
          },
          {
            id: 3739,
            nickname: "Luxury",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/5c/5c81f01ee1cf5ae51aa27f38b5bb6e7f95ecd708_full.jpg",
            country: null,
            steam_id64: "76561198025824140"
          },
          {
            id: 5235,
            nickname: "^<^发酵烤牛奶^>^",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/c3/c3b92a088a7b418fca5f7f3b699b87bfb544fd2c_full.jpg",
            country: "CN",
            steam_id64: "76561198127788380"
          },
          {
            id: 4150,
            nickname: "AKAZA",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/54/54b8aec0b351f0a73579c91189bc09dad4587682_full.jpg",
            country: "RU",
            steam_id64: "76561199010454212"
          }
        ]
      }
    ]
  })
};
</script>

<style lang="scss">
.winners-2021-section {
  margin-bottom: 30px;
  &__list {
    list-style: none;
    background: url("~@/assets/img/prizes/prize-bg.png") center no-repeat;
    > [class*="col-"] {
      padding-top: 25px;
      padding-bottom: 25px;
    }
  }
}
</style>
